import script from "./logout-peserta.vue?vue&type=script&lang=js"
export * from "./logout-peserta.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__